/* istanbul ignore file */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const filtersCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const {galleryShowSort, galleryShowFilters} = styleParams.booleans;

  return {
    filtersSubmitButtonFullWidthOnlySort: galleryShowSort ? '100%' : '132px',
    filtersSubmitButtonFullWidthOnlySortWhenFiltersDisabled: galleryShowSort && !galleryShowFilters ? '100%' : '132px',
  };
};

export const filtersShouldRenderVars = ({booleans, isMobile}: ShouldRenderVarsFnParams) => {
  const {galleryShowFilters} = booleans;
  const shouldRenderSortOptionsWhenFiltersDisabled = !galleryShowFilters;
  const shouldRenderFiltersHeader = isMobile ? true : galleryShowFilters;

  return {
    shouldRenderSortOptionsWhenFiltersDisabled,
    shouldRenderFiltersHeader,
  };
};
